import React, { useState, useEffect } from 'react'
import { Table } from 'reactstrap';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import CurrencyFormat from 'react-currency-format';
import * as moment from 'moment';
import infoicon from "web/assets/images/info-icon.png";
import Tooltip from '@material-ui/core/Tooltip';
import Spinner from 'web/components/Spinner';
import AlertModal from 'web/components/AlertModal';
import { FORMAT } from 'web/components/utils/dateOfBirthValidation';
import Button from 'web/components/Button';
import { postLoadV2BidWithdraw } from 'redux/actions/withDraw';
import { Container, PalletsInformation } from './bidsStyle'
import styles from './table.module.scss';
import { fetchLanguageContentNew } from 'redux/actions/language';

const Bids = ({ myPostType, response, callBackFun }) => {
    let history = useHistory();
    const dispatch = useDispatch();
    const token = localStorage.getItem('token');

    const [alertType, setAlertType] = useState();
    const [modal, setModal] = useState(false);
    const [modalContent, setModalContent] = useState('');
    const [modalLink, setModalLink] = useState('');
    const toggleModal = () => setModal(!modal);

    const storedData = useSelector(
        (state) => state.storedData.payload
    );
    let authId = storedData?.authId

    const currentLanguage = useSelector(state => state.language.currentLanguage)
    const languageContentNew = useSelector(state => state.language.languageContentNew)
    const [pageLanguageContents, setPageLanguageContents] = useState()
    const [headerArr, setHeaderArr] = useState([])

    useEffect(() => {
        if (languageContentNew?.MyBids_Page) setPageLanguageContents(languageContentNew.MyBids_Page)
        else dispatch(fetchLanguageContentNew(currentLanguage))
    }, [languageContentNew])

    useEffect(() => {
        setHeaderArr([
            { title: pageLanguageContents?.Bids_Content[8]?.PostName },
            // { title: pageLanguageContents?.Bids_Content[23]?.Location },
            { title: "Type" },
            { title: pageLanguageContents?.Bids_Content[9]?.OfferedPrice },
            { title: pageLanguageContents?.Bids_Content[24]?.RequestedDate },
            { title: pageLanguageContents?.Bids_Content[12]?.BidStatus },
            { title: '' }
        ])
    }, [pageLanguageContents])

    let title = '';

    const loaderVisible = useSelector(
        (state) => state.appReducer.loaderVisible
    );

    const withDrawFun = async (items, index) => {
        let data =
        {
            bidId: items?.bidId,
            authId: authId
        }
        let responseSet = await dispatch(postLoadV2BidWithdraw(data, token));;
        responseMsg(responseSet)
    }

    const responseMsg = (response) => {
        if (response?.success) {
            setAlertType("acknowledge")
            setModalContent(response?.data?.msg);
            setModalLink('');
            toggleModal();
        } else {
            if (response.statusCode === 401) {
                history.push('./sign-in')
                window.location.reload(false);
            } else {
                setModalContent(response?.data?.error?.message || response?.message || 'Something went wrong, please try again in some time.');
                setModalLink('');
                toggleModal();
            }
        }
    }

    const withDrawAction = (items, index) => {
        return (
            <Button
                type='app-green-button'
                handleClick={() => {
                    withDrawFun(items, index)
                }}>
                {pageLanguageContents?.Bids_Content[21]?.Withdraw}
            </Button>
        )
    }

    const viewPostDetails = (items) => {
        let postId = items?.needId
        let prevPage = 'bid'

        let obj = {
            id: postId?.toString(),
            postType: 'PostLoad',
            prevPage: prevPage.toString()
        }
        dispatch({ type: 'DETAILS', payload: obj })

        history.push({
            pathname: '/details',
        })
    }
    const tooltipAttach = (items) => {
        return <Tooltip
            placement="bottom"
            leaveTouchDelay={10000}
            classes={{ popper: 'table-styleed-tooltip' }}
            arrow title={
                <>
                    <ul>
                        <li>
                            <span className="col-6 text-bold">{pageLanguageContents?.Bids_Content[16]?.PalletType}</span>
                            <span className="col-6">
                                {items?.palletType ? items?.palletType : 'NA'}
                            </span>
                        </li>
                        <li>
                            <span className="col-6 text-bold">
                                {pageLanguageContents?.Bids_Content[17]?.Grade}
                            </span>
                            <span className="col-6">
                                {items?.grade ? items?.grade : 'NA'}
                            </span>
                        </li>
                        <li>
                            <span className="col-6 text-bold">
                                {pageLanguageContents?.Bids_Content[18]?.Size}
                            </span>
                            <span className="col-6">{items?.size ? items?.size : 'NA'}</span>
                        </li>
                        <li>
                            <span className="col-6 text-bold">
                                {pageLanguageContents?.Bids_Content[19]?.Quantity}
                            </span>
                            <span className="col-6">
                                <span className="col-6">{items?.qty ? items?.qty.toLocaleString() : 'NA'}
                                    <>{items?.lots && <>({items?.lots} lot)</>}</>
                                </span>
                            </span>
                        </li>
                    </ul>
                </>}><img src={infoicon} className="info-icon" alt='infoicon' /></Tooltip>
    }
    const tableData = (items, index) => {
        return (
            <tr key={index}>
                <td style={{ cursor: 'pointer', width: '30vw' }} onClick={() => viewPostDetails(items)}>
                    {items?.postName} {tooltipAttach(items)}
                </td>
                <td style={{ width: '17vw' }}>
                    {items?.location}
                </td>
                <td style={{ width: '17vw' }}>
                    <div className="d-flex align-items-center">
                        <div style={{ whiteSpace: 'nowrap' }}>
                            <CurrencyFormat value={items?.bidPrice.toFixed(2)} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                            {`, ${items?.qty.toLocaleString()} Qty`}
                        </div>
                    </div>
                </td>
                <td style={{ width: '17vw' }}>
                    {/* {moment(new Date(items?.requestedDate * 1000).toLocaleString()).format(FORMAT)} */}
                    {moment(items?.requestedDate).format(FORMAT)}
                </td>
                <td style={{ width: '17vw' }}>
                    {items?.bidStatus}
                </td>
                <td style={{ width: '17vw' }}>
                    {(items?.bidStatus === "Bid Placed" || items?.bidStatus === "Alt Bid Placed") && <>
                        {withDrawAction(items, index)}
                    </>}
                </td>
            </tr>
        )
    }
    const tableAttach = () => {
        return (<>
            {loaderVisible && <Spinner />}
            <Table responsive>
                <thead>
                    <tr>
                        {headerArr.map((items, index) => (
                            <th key={index}>{items.title}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {response?.bidList.map((items, index) => (
                        tableData(items, index)
                    ))}
                </tbody>
            </Table>

            <AlertModal
                isOpen={modal}
                toggle={toggleModal}
                title={title}
                alertType={alertType}
                content={modalContent}
                link={modalLink}
                callBackAlert={(val) => {
                    if (val === "acknowledge") {
                        callBackFun()
                    }
                }}
            />
        </>
        )
    }
    return (
        <Container>
            <PalletsInformation>
                <div className={styles.tableContainer}>
                    {tableAttach()}
                </div>
            </PalletsInformation>
        </Container>
    )
}

export default Bids;